module.exports = __webpack_public_path__ + "img/telephone-icon.41549697.svg";